export default __webpack_public_path__ + "static/media/trip-cancellation.c650bad1.png";